module KendoWidgets
{
	export class LegendOptions
	{
		title?: string;
		fontSize?: number;
		css?: string;
	}

	export class Legend extends kendo.ui.Widget implements KendoWidget
	{
		public controlType(): ControlTypeEnum { return ControlTypeEnum.Legend; }

		constructor(element: Element, options?: KendoWidgets.LegendOptions)
		{
			if (options == null)
				options = new KendoWidgets.LegendOptions();

			if (options.title == null) options.title = "";

			super(element, options);
			let that = this;

			$(element).addClass("k-legend");

			//#region Title
			let noPadding = "";
			if (options.title == "")
				noPadding = "style='padding: 0px;'";
			$("<h1><span class='k-legend-title' " + noPadding + ">" + options.title + "</span></h1>").appendTo(element);
			//#endregion

			//#region Font size
			if (options.fontSize != null)
				$(element).find(".k-legend-title").css("font-size", options.fontSize + "px");
			//#endregion

			//#region CSS
			if (options.css != null)
				(element as HTMLDivElement).style.cssText += options.css;
			//#endregion
		}

		appendTo(element: string | HTMLElement | JQuery)
		{
			this.element.appendTo(element);
		}

		prependTo(element: string | HTMLElement | JQuery)
		{
			this.element.prependTo(element);
		}
	}

	Legend.fn = Legend.prototype;
	Legend.fn.options = $.extend(true, {}, kendo.ui.Widget.fn.options);
	Legend.fn.options.name = "Legend";
	kendo.ui.plugin(Legend);
}

interface JQuery
{
	kendoLegend(options?: KendoWidgets.LegendOptions): JQuery;
}